module.exports = __webpack_public_path__ + "static/img/404.cfe4d32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.png
// module id = CgFv
// module chunks = 0